import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { TenantCommunicationTemplate } from '../communication-templates/communication-template.interface';
import { Journey } from './journey.interface';

export const JOURNEY_INCLUDES = ['journeyType', 'teams', 'referrals', 'referrals.referralType'];

export class JourneyService {
   async getJourneys(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<Journey>>>('/journeys', { params: { ...query } });
      return response.data;
   }

   async getJourneyTemplate(id: number) {
      const response = await http.get<{ data: TenantCommunicationTemplate }>(`/journeys/${id}`);
      return response.data;
   }

   async getJourney(id: number, query: LocationQuery) {
      const response = await http.get<{ data: Journey }>(`/journeys/${id}`, { params: { ...query } });
      return response.data;
   }

   async postJourney() {
      throw Error('Method not implemented');
   }

   async putJourney(id: number) {
      const response = await http.put<ApiResource<Journey>>(`/journeys/${id}`, { params: { include: JOURNEY_INCLUDES.join(',') } });
      return response.data;
   }

   async deleteJourney() {
      throw Error('Method not implemented');
   }
}
